import { useNavigate } from "react-router-dom";

const QuickActionCard = ({ name = "", icon = "", path = "#" }) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="card cursor-pointer quick-action-card"
        onClick={() => navigate(path)}
      >
        <div className="card-body">
          <div className="d-flex gap-3 align-items-center">
            <img src={icon} alt={name} />
            <span className="fs14px">{name}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuickActionCard;
